// Landing ("thank you") render of the tempurpedic generic FormPage, shown after
// a successful submission. Same UtilityPage shell as FormPageTemplate, but
// content__copy holds the thank-you rich text instead of the form.
import React from "react";

import { templates } from "@reactivated";

import { ContentTitle } from "../components/ContentTitle";
import { PageSkeleton } from "../components/PageSkeleton";
import { UtilitySideNav } from "../components/UtilitySideNav";

export const Template = (
    props: templates.FormPageLandingTemplate,
): React.JSX.Element => {
    const {
        nav_items,
        nav_name,
        has_right_bar,
        right_bar_items,
        content_title,
        content_title_phone_href,
        content_title_phone_display,
        thank_you_html,
    } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
                {nav_items.length > 0 && (
                    <div className="l-side-nav">
                        <UtilitySideNav items={nav_items} navName={nav_name} />
                    </div>
                )}

                <div className="l-side-nav-content">
                    <ContentTitle
                        title={content_title}
                        phoneHref={content_title_phone_href}
                        phoneDisplay={content_title_phone_display}
                    />

                    <div
                        className={
                            has_right_bar
                                ? "content__copy"
                                : "content__copy--full-width"
                        }
                    >
                        <div>
                            <div
                                className="rich-text"
                                dangerouslySetInnerHTML={{
                                    __html: thank_you_html,
                                }}
                            />
                        </div>
                    </div>

                    {has_right_bar && (
                        <aside className="content__aside">
                            {right_bar_items.map((item, i) => (
                                <div
                                    key={i}
                                    className={`w-block-${item.block_type} block-${item.block_type}`}
                                    dangerouslySetInnerHTML={{
                                        __html: item.html,
                                    }}
                                />
                            ))}
                        </aside>
                    )}
                </div>
            </div>
        </PageSkeleton>
    );
};
